module.exports = __webpack_public_path__ + "common/tp-featured5-8034536a6ba13b59b541fdfcd89f01e2.svg";